module.exports = __webpack_public_path__ + "static/media/electromovilidad vehiculos particulares 60.d0ce53d0.jpg";